import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const GeneralContainer = styled.div`
  position: relative;
  min-height: 400px;

  > div {
    height: 100%;
    box-sizing: border-box;
    background: ${props => props.theme.palette.general.light};
    margin: 14px 7px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    border-radius: 4px;
    transition: all ease-in-out 0.4s;
    transform: scale(1);
    z-index: 0;

    &:hover {
      position: absolute;
      left: 0;
      right: 0;
      z-index: 10;
      transform: scale(1.05);
      height: 110%;
      transform-origin: center;
      box-shadow: 0 10px 24px 0 rgba(0, 0, 0, 0.02), 0 8px 20px -2px rgba(0, 0, 0, 0.06), 0 6px 10px -6px rgba(0, 0, 0, 0.1);

      .actions {
        height: auto;
        min-height: 80px;
        opacity: 1;
      }
    }

    .actions {
      height: 0;
      overflow: hidden;
      transition: opacity ease-in-out 0.3s;
      opacity: 0;
    }
  }

  .subscription-label {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    font-size: 14px;
    color: ${props => props.theme.palette.general.light};
    padding: 6px;
    border-radius: 4px 4px 0 0;
  }

  .image__wrapper {
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.has-label {
      margin-top: 15px;
    }

    > img {
      object-fit: contain;
    }
  }

  .brand {
    color: ${props => props.theme.palette.primary.alphaDark};
  }
`

export const SofiaWrapper = styled.div`
  padding: 22px 25px;
  text-align: center;
  box-shadow: ${props => props.theme.palette.general.boxShadow};

  .product-name {
    text-decoration: none;
    color: ${props => props.theme.palette.general.strong};
    font: ${font('default', 'normal', '18px/1.3')};
    display: block;
    height: 48px;
    margin: 5px 0 12px;
    overflow: hidden;
  }

  button {
    margin: auto;

    > div {
      padding: 8px 15px;
    }
  }

  .subscription-label {
    background: ${props => props.theme.palette.primary.gamma};
  }
`

export const LivWrapper = styled.div`
  border: 1px solid ${props => props.theme.palette.general.grey};
  border-radius: 5px;
  padding: 22px 15px;
  margin: 14px 7px;
  text-align: center;

  .product-name {
    text-decoration: none;
    color: ${props => props.theme.palette.primary.alphaDark};
    font: ${font('default', 'normal', '19px/1.5')};
    display: block;
    height: 52px;
    margin: 5px 0 10px;
    overflow: hidden;
  }

  button {
    margin: auto auto 0;
    background: ${props => props.theme.palette.primary.alpha};
    font: ${font('default', 'medium', '18px/1.2')};

    > div {
      padding: 8px 15px;
    }
  }

  .subscription-label {
    background: ${props => props.theme.palette.primary.alpha};
  }
`
export const PriceWrapper = styled.div<any>`
  margin: 15px 0 12px;

  span.regularPrice {
    font: ${font('default', 'medium', '20px/1.2')};
    color: ${props => props.theme.palette.general.strong};
  }
`
